import Edit from './edit'

export default Edit
